import { createHighlighter, type Highlighter } from "shiki";

let highlighterPromise: Promise<Highlighter> | null = null;

const LANGS = [
  "json", "javascript", "typescript", "python", "sql", "bash",
  "html", "css", "xml", "yaml", "markdown", "graphql",
] as const;

function getHighlighter(): Promise<Highlighter> {
  if (!highlighterPromise) {
    highlighterPromise = createHighlighter({
      themes: ["github-dark", "github-light"],
      langs: [...LANGS],
    });
  }
  return highlighterPromise;
}

export async function highlightCode(
  code: string,
  language: string,
  theme: "github-dark" | "github-light" = "github-dark",
): Promise<string | null> {
  try {
    const h = await getHighlighter();
    const langId = language.toLowerCase();
    const loaded = h.getLoadedLanguages();
    if (!loaded.includes(langId as typeof loaded[number])) return null;
    return h.codeToHtml(code, { lang: langId, theme });
  } catch {
    return null;
  }
}
